import { PageRoute } from "./Router";
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return <PageRoute />;
}

export default App;
